import { FormErrors } from '../../hocs/types';
import { getKeys } from '..';

export const ACCEPTED_LOGO_FORMATS = ['image/png', 'image/jpeg'] as const;

export function makeErrorsSameShapeAsValues<Values, T extends FormErrors<Values>>(errors: T, values: Values & object) {
    const newObject = { ...(errors as object) } as T;

    for (const key of getKeys(errors)) {
        if (!values.hasOwnProperty(key)) {
            delete newObject[key];
        }
    }

    return newObject as FormErrors<Values>;
}

export function removeDuplicates(arr: string[]) {
    return arr.filter((item, i) => {
        return !arr.slice(i + 1).includes(item);
    });
}

export const getParameterWithDefault = <T, K extends keyof T, Defaults>(
    skillSettings: T,
    defaults: Defaults,
    parameter: K & keyof Defaults,
) => {
    return typeof skillSettings[parameter] !== 'undefined' ? skillSettings[parameter] : defaults[parameter];
};

export const hasSpecialChars = (text: string) => /[$&+~,:;=?@#|/'"`<>.\\^*()%! ]/.test(text);
